// 縦キーモード（指別）
export const TYPING_MODE_KEYS_COLUMN = {
  leftPinky: {
    name: '左手小指',
    keys: ['Q', 'A', 'Z']
  },
  leftRing: {
    name: '左手薬指',
    keys: ['W', 'S', 'X']
  },
  leftMiddle: {
    name: '左手中指',
    keys: ['E', 'D', 'C']
  },
  leftIndex1: {
    name: '左手人差し指1',
    keys: ['R', 'F', 'V']
  },
  leftIndex2: {
    name: '左手人差し指2',
    keys: ['T', 'G', 'B']
  },
  rightPinky: {
    name: '右手小指',
    keys: ['P']
  },
  rightRing: {
    name: '右手薬指',
    keys: ['O', 'L']
  },
  rightMiddle: {
    name: '右手中指',
    keys: ['I', 'K']
  },
  rightIndex1: {
    name: '右手人差し指1',
    keys: ['U', 'J', 'M']
  },
  rightIndex2: {
    name: '右手人差し指2',
    keys: ['Y', 'H', 'N']
  }
};
